import { render } from "./LoadingSpinner.vue?vue&type=template&id=1ffdafca&ts=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/weather-widget-vue/weather-widget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__